import t from 'tcomb';

const Field = t.enums.of('email birth_date zip district mobile gender country', 'Field');

module.exports = Field;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Field.js
 **/